import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { Helmet } from "react-helmet-async";

const Home = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();



  return (
    <>
      <Helmet>
        <title>Dashbard Griya Vidya</title>
      </Helmet>
      <div>
        <div className="pc-container">
          <div className="pc-content">
            <div className="row">
              {data?.map((item, index) =>
                item.type === "Card" ? (
                  item?.data?.map((subItem, subIndex) => (
                    <div className="col-xl-3 col-md-6" key={subIndex}>
                      <div className="card comp-card">
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col">
                              <h5 className="m-b-20">{subItem.title}</h5>
                              <h3>{subItem.data}</h3>

                            </div>
                            {/* <div className="col-auto">
                            <i className="fas fa-eye bg-light-primary text-primary"></i>
                          </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : null
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );



};

export default Home;
